export const addEditFormLayout = {
  labelCol: {
    sm: { span: 7 },
    md: { span: 8 },
    lg: { span: 7 },
    xl: { span: 6 },
  },
  wrapperCol: { span: 18 },
};
